import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../../../shared/services/authentication.service';
import * as $ from 'jquery';
import { MatDialogRef, MatDialog } from '@angular/material';
import { ChangepasswordComponent } from '../../../shared/components/changepassword/changepassword.component';
import { UserprofileComponent } from "../../../userprofile/userprofile.component"
import { PopupComponent } from "../popup/popup.component";
import { NotificationService } from '../../services/notification.service';
import { ngxLoadingAnimationTypes, NgxLoadingComponent } from "ngx-loading";

declare var jQuery: any;

interface param {
  key: string,
  value: string
}

@Component({
  selector: 'main-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})

export class HeaderComponent implements OnInit {
  userPermission: any = localStorage.getItem("UserPermission").split(',');

  username: string;
  userAvatar: string;
  userFullName: string;
  userEmail: string;
  dialogRef: MatDialogRef<ChangepasswordComponent>;
  dialogPopup: MatDialogRef<UserprofileComponent>;
  mouse_is_inside: boolean = false;
  notificationNumber: number = 0;
  NotificationContent: string;
  auth: any = JSON.parse(sessionStorage.getItem("auth"));
  notificationList: Array<any> = [];
  @ViewChild('ngxLoading') ngxLoadingComponent: NgxLoadingComponent;
  public ngxLoadingAnimationTypes = ngxLoadingAnimationTypes;
  loadingConfig: any = {
    'animationType': ngxLoadingAnimationTypes.circle,
    'backdropBackgroundColour': 'rgba(0,0,0,0.1)',
    'backdropBorderRadius': '4px',
    'primaryColour': '#ffffff',
    'secondaryColour': '#999999',
    'tertiaryColour': '#ffffff'
  }
  loading: boolean = false;
  awaitLoadPage: boolean = false;

  constructor(
    public dialog: MatDialog,
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private notiService: NotificationService) { }

  ngOnInit() {
    this.username = localStorage.getItem("Username");
    this.userAvatar = localStorage.getItem("UserAvatar");
    this.userFullName = localStorage.getItem("UserFullName");
    this.userEmail = localStorage.getItem("UserEmail");
    //this.getNotification();
    $(".user-content-button").click((evt) => {
      $("#user-content").toggle();
    });

    $("body").mouseup((e) => {
      var container = $("#user-content");

      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        container.hide();
      }

      var sndContainer = $("#notification-content");

      // if the target of the click isn't the container nor a descendant of the container
      if (!sndContainer.is(e.target) && sndContainer.has(e.target).length === 0) {
        sndContainer.hide();
      }
    });
  }

  // Mở giao diện đổi Password
  openChangePassword() {
    let account = this.username;
    let _name = this.userFullName;
    let _email = this.userEmail;
    let _avatar = this.userAvatar;
    this.dialogRef = this.dialog.open(ChangepasswordComponent,
      {
        data: { accountName: account, name: _name, email: _email, avatar: _avatar }
      });
    this.dialogRef.afterClosed().subscribe(result => {
    });
    $("#user-content").toggle();

  }

  // Mo giao dien UserProfile
  goToViewProfile() {
    this.router.navigate(['/userprofile']);
  }

  goToHome() {
    this.router.navigate(['/home']);
  }

  logout() {
    this.authenticationService.logout();
    this.router.navigate(['/login']);
  }

  //Quay trở lại trang trước
  goBack() {
    let backUrl: string = '';
    let stringArrayUrl: string = sessionStorage.getItem('arrayUrl');
    let arrayUrl: Array<any> = stringArrayUrl.split(',');

    if (arrayUrl.length > 1) {
      backUrl = arrayUrl[arrayUrl.length - 2];
      arrayUrl.pop();

      sessionStorage.removeItem('arrayUrl');
      sessionStorage.setItem('arrayUrl', arrayUrl.toString());

      //trường hợp đặc biệt: preview chi tiết đơn hàng
      if(!this.checkUserPermission('order/list')) {
        sessionStorage.setItem('previewOrder', 'true');
      }

      if (backUrl.indexOf(';') != -1) {
        let listStringParams: string = backUrl.slice(backUrl.indexOf(';') + 1);
        backUrl = backUrl.slice(0, backUrl.indexOf(';'));

        if (listStringParams.indexOf(';')) {
          //nếu url có nhiều hơn 1 param
          let arrayStringParam = listStringParams.split(';');
          let listParam: Array<param> = [];
          arrayStringParam.forEach(item => {
            let indexCharEqual = item.indexOf('=');
            let param: param = { key: '', value: ''};
            param.key = item.slice(0, indexCharEqual);
            param.value = item.slice(indexCharEqual + 1);
            listParam.push(param);
          });

          let option: Object = {};
          listParam.forEach(param => {
            option[param.key] = param.value;
          });

          this.router.navigate([backUrl, option]);
        } else {
          //nếu url chỉ có một param
          let indexCharEqual = listStringParams.indexOf('=');
          let param: param = { key: '', value: ''};
          param.key = listStringParams.slice(0, indexCharEqual);
          param.value = listStringParams.slice(indexCharEqual + 1);

          let option: Object = {};
          option[param.key] = param.value;

          this.router.navigate([backUrl, option]);
        }
      } else {
        this.router.navigate([backUrl]);
      }
    }
  }

  checkUserPermission(permission: string) {
    return this.userPermission.indexOf(permission) !== -1;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/header/header.component.ts